<template>
  <div class="">
      <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
        <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
          <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
            WELCOME TO THE STARLINE SECURITY <br/>PORTAL DEMO
          </h2>

          <p>
            This demonstration has been designed to showcase some of our portal’s main
            functionalities and give you a a few examples of how some items may be ordered.
          </p>

          <h4 class="tw-text-primary tw-font-helvetica">
            Before you proceed:
          </h4>

          <label class="form__label">
            <input
              v-model="termOne"
                   type="checkbox"
                   hidden
                   class="form__checkbox"
            >
            <span class="form__checkbox_icon tw-inline-block tw-mr-0"></span>
            <span class="">
              Please understand the <span class="tw-text-primary">prices shown are estimates only</span> and may differ from once you signed up as a dealer.
            </span>
          </label>

          <label class="form__label">
            <input
              v-model="termTwo"
              type="checkbox"
              hidden
              class="form__checkbox"
            >
            <span class="form__checkbox_icon tw-inline-block tw-mr-0"></span>
            <span class="">
              Any estimates, quotes sent as emails are for demonstration purposes only and <span class="tw-text-primary">can’t be used for commercial purposes</span>
            </span>
          </label>

          <label class="form__label">
            <input
              v-model="termThree"
              type="checkbox"
              hidden
              class="form__checkbox"
            >
            <span class="form__checkbox_icon tw-inline-block tw-mr-0"></span>
            <span class="">
              The use of this demo is guided by Starline’s Terms & Conditions. By checking this box you <span class="tw-text-primary">agree and accept them</span>. You can view them by <a href="#" target="_blank" class="tw-text-primary">clicking this link.</a>
            </span>
          </label>
        </div>
        <template v-slot:footer>
          <div class="tw-mt-4">
            <button title="To start the demo please agree with all terms above." @click="start" class="btn btn_transparent tw-m-0 tw-flex tw-items-center" :disabled="!allTermsTicked" :class="{'btn_disabled tw-cursor-not-allowed hover:tw-border-current': !allTermsTicked}">
              <svg-icon name="solid/caret-right" class="tw-w-6 tw-h-6" /> <span class="tw-ml-2">START DEMO</span>
            </button>
          </div>
        </template>
      </Modal>
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
export default {
    name: 'DemoWizard',
    components: {
        Modal
    },
    data() {
      return {
        termOne: true,
        termTwo: true,
        termThree: true,
        customerDetails: {
          address: '',
          email: '',
          customer_id: '',
          name: '',
          phone: '',
          postcode: '',
          state_id: '',
          suburb: '',
          user_id: '',
          is_guest: 0,
          order_id: localStorage.getItem('order_id') || '',
        },
        reference: null
      }
    },
    computed: {
      allTermsTicked() {
        return this.termOne && this.termTwo && this.termThree
      }
    },
    mounted() {
      // this.reference = this.items.reference
      this.$store.dispatch('customerDetails/getExistingCustomer')
    },
    methods: {
      start() {
          this.$store.commit('demoWizard/nextStep')
          // this.$store.commit('orderPreview/clearItems')
          // this.customerDetails.is_guest = 1
          // this.$store.dispatch('customerDetails/sendData', {customerDetails: this.customerDetails, reference: this.reference})
      }
    }
}
</script>

<style lang="scss">
  .demo-wizard {
    .modal_content {
      @apply tw-rounded-md tw-p-4;
    }
  }
</style>
